var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "BattleDialog" } },
    [
      _vm.visible
        ? _c(
            "el-dialog",
            {
              staticClass: "battleDialog",
              attrs: {
                top: "30vh",
                visible: _vm.visible,
                show: _vm.visible,
                "show-close": false,
                "close-on-press-escape": false,
                "close-on-click-modal": _vm.closeOnClickModal,
                "append-to-body": ""
              },
              on: {
                "update:visible": function($event) {
                  _vm.visible = $event
                }
              }
            },
            [
              _c("div", [
                _vm.type === 2 || _vm.type === 3
                  ? _c("div", { staticClass: "tipTitle" }, [
                      _vm._v("\n        " + _vm._s(_vm.tipTitle) + "\n      ")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "content" }, [
                  _vm._v("\n        " + _vm._s(_vm.content) + "\n      ")
                ]),
                _vm._v(" "),
                _vm.type === 1 || _vm.type === 3
                  ? _c("div", { staticClass: "btnBox" }, [
                      _c(
                        "div",
                        {
                          staticClass: "confirm cursor",
                          on: { click: _vm.yesBtn }
                        },
                        [_vm._v(_vm._s(_vm.okTxt))]
                      )
                    ])
                  : _c("div", { staticClass: "btnBox2" }, [
                      _c(
                        "div",
                        {
                          staticClass: "cancel cursor",
                          on: { click: _vm.noBtn }
                        },
                        [_vm._v(_vm._s(_vm.cancelTxt))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "confirm cursor",
                          on: { click: _vm.yesBtn }
                        },
                        [_vm._v(_vm._s(_vm.okTxt))]
                      )
                    ])
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-1f5dd0f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-1f5dd0f0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/plugin/BattleDialog/src/main.vue
// module id = null
// module chunks = 